export const addFavoriteLabel = "E6d";
export const newFavoritePickedText = "F6d";
export const renameFavoriteLabel = "G6d";
export default {addFavoriteLabel,newFavoritePickedText,renameFavoriteLabel};